import React from "react"
import cheerio from "cheerio"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import { Carousel } from "react-responsive-carousel"
import { Link, useStaticQuery } from "gatsby"
import { Header } from "../../components/common"
import Helmet from "react-helmet"
import Img from "gatsby-image"
/*
const findFeeback = (html) => {
    const markdown = ['<!--kg-card-begin: markdown-->', '<!--kg-card-end: markdown-->']
    let i = 0, j = 0
    for (i = 0; i < html.length - markdown[0].length; i++) {
        for (j = 0; j < markdown[0].length; j++) {
            if (markdown[0][j] != html[i + j]) {
                break
            }
        }
        if (j == markdown[0].length) return true
    }
}*/

export default props => {
  const html = cheerio.load(props.post.html)
  const divHtml = cheerio.load(props.post.html)
  const carousel = []
  const images = []
  
  divHtml(`.kg-card`).addClass(`text-center `)
  divHtml(`ul`).addClass(`p-list pb-4`)
  divHtml(`p`).addClass(`lead b6 container`)
  divHtml(`li`).addClass(`lead b6 container`)
  divHtml(`h5`).addClass(`pb-2 text-uppercase center h4 container`)
  divHtml(`h3`).addClass(`pt-4 container`)
  divHtml(`img`)
    .first()
    .addClass(`w-100`)
  divHtml(`p > strong`)
    .parent()
    .addClass(`pb-4 pt-2 container`)
   
  divHtml(`img`).addClass(`text-center m-auto pb-5 custom-width-1`)
  divHtml(`img`).attr("alt", props.post.title + " related")
  divHtml(`img`).attr("title", props.post.title)

  divHtml(`blockquote`).wrap('<div class="w-75 container"></div>')
  divHtml(`blockquote`).addClass(`p-4 mt-4 mb-4 portfolio-quote`)
  divHtml("iframe").addClass(`container mt-4 `)
  divHtml("iframe").attr("height", "600")
  divHtml("figcaption").addClass(`mt-2 mb-4`)

  const url = html(`img`)
    .attr("src")
    .replace("http://", "https://")
  html(`img`).attr("src", url)

  const androidLink = html("#android").attr("href")
  const iosLink = html("#ios").attr("href")

  // divHtml(`img`).attr('src').replace('http://', 'https://');
  // divHtml(`img`).attr("src", url);

  props.portfolios.edges.map((node, i) => {
    if (props.post.title === node.node.title) {
      props.post.previous = props.portfolios.edges[i - 1]
      props.post.next = props.portfolios.edges[i + 1]
    }
  })

  props.post.tags.map((tag, i) => {
    if (tag.name.includes("#")) {
      tag.name = tag.name.replace("#", "")
      tag.name = tag.name.split(":")
      switch (tag.name[0]) {
        case `client`: {
          props.post.client = tag.name[1]
          break
        }
        case `project`: {
          props.post.project = tag.name[1].replace(`_`, " ")
          break
        }
        case `platform`: {
          props.post.platform = tag.name[1]
          break
        }
      }
    }
  })
  divHtml(`.kg-image-card`).map((i, el) => {
    const newUrl = el.childNodes[0].attribs["src"].replace(
      "http://",
      "https://"
    )
    el.childNodes[0].attribs["src"] = newUrl
  })

  html(`.kg-image-card`).map((i, el) => {
    images.push(el.childNodes[0].attribs)
  })

  html(`.kg-gallery-image`).map((i, el) => {
    carousel.push(el.childNodes[0].attribs)
  })

  html(`.kg-gallery-card`).remove()
  html(`ul`).remove()
  html(`p`).remove()
  html(`img`).addClass(`text-center m-auto pb-5`)
  html(`h3`).remove()
  html(`h4`).remove()
  const data = useStaticQuery(graphql`
    query {
      getNavigation: file(
        relativePath: { eq: "baseline_navigate_next_black_24dp.png" }
      ) {
        ...imageQuery
      }
    }
  `)
  return (
    <main role="main" className="clientPortfolio" id="info">
      <Helmet>
        <title>
          {`Portfolios | ${props.post.title
            .split(" ")
            .splice(0, 6)
            .join(" ") + "..."}`}
        </title>
        <meta
          name="twitter:url"
          content={`https://www.tarento.com/${props.post.url.split("/")[3]}/`}
        ></meta>
        <meta
          property="og:url"
          content={`https://www.tarento.com/${props.post.url.split("/")[3]}/`}
        ></meta>
        <meta name="twitter:title" content={props.post.title}></meta>
        <meta property="og:title" content={props.post.title}></meta>
        <meta name="description" content={props.post.excerpt}></meta>
        <meta name="twitter:description" content={props.post.excerpt}></meta>
        <meta property="og:description" content={props.post.excerpt}></meta>
        <meta
          name="keywords"
          content={`Tarento portfolios, tarento projects, ${props.post.title}`}
        ></meta>
        <meta property="og:image" content={props.post.feature_image}></meta>
        <meta name="twitter:image" content={props.post.feature_image}></meta>
        <meta name="twitter:card" content={props.post.excerpt}></meta>
        <meta property="og:type" content="case studies"></meta>
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:site" content={props.post.title}></meta>
        <link
          href={`https://www.tarento.com/${props.post.url.split("/")[3]}/`}
          rel="canonical"
        />
      </Helmet>
      <Header />
      <section className="layout pt-4">
        <div className="jumbotron layout bg-white pb-0 pt-0">
          <div className="container">
            <div className="row mb-4 pl-0 ml-0 ">
              <Link to="/portfolio/" className="link-underline">
                <label className="breadcumb-1 pt-3 ">Portfolio</label>
              </Link>
              <div className="navigate-1 pt-3">
                <Img
                  fluid={data.getNavigation.childImageSharp.fluid}
                  alt="navigate"
                />
              </div>
              <label className="breadcumb-1 pt-3">{props.post.title}</label>
            </div>
            <div className="row  align-items-center">
              <div className="col-md-12 m-auto">
                {props.post.title && (
                  <h1 className="text-uppercase pb-4 h2 h2LS">
                    {props.post.title}
                  </h1>
                )}

                {(props.post.client ||
                  props.post.project ||
                  props.post.platform) && (
                  <div className="col-md-12 col-lg-7 mr-lg-5">
                    <div className="digitalInfo">
                      <div className="role d-flex flex-column flex-md-row justify-content-between ">
                        {props.post.client && (
                          <div className="status mt-4">
                            <span className="block text-uppercase caption1 font-weight-bold b6 pb-1">
                              Client
                            </span>
                            <span className="block font-weight-bold">
                              {props.post.client.toUpperCase()}
                            </span>
                          </div>
                        )}
                        {props.post.project && (
                          <div className="status mt-4">
                            <span className="block text-uppercase caption1 font-weight-bold b6 pb-1">
                              Project
                            </span>
                            <span className="block font-weight-bold">
                              {props.post.project.toUpperCase()}
                            </span>
                          </div>
                        )}
                        {props.post.platform && (
                          <div className="status mt-4">
                            <span className="block text-uppercase caption1 font-weight-bold b6 pb-1">
                              Platform
                            </span>
                            <span className="block font-weight-bold">
                              {props.post.platform.toUpperCase()}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="layout">
          <div className="row m-0 p-0">
            <div className="col-12 p-0">
              <div
                className=""
                dangerouslySetInnerHTML={{ __html: divHtml.html() }}
              ></div>
            </div>
          </div>
        </div>
      </section>
      {carousel.length != 0 && (
        <section className="layout">
          <div className="container">
            <div className="row">
              <Carousel
                showThumbs={false}
                infiniteLoop={true}
                autoPlay={true}
                interval={2000}
              >
                {carousel.map(elem => (
                  <div key={elem.src}>
                    <img src={elem.src} alt="Carousel" title="Carousel" />
                  </div>
                ))}
              </Carousel>
            </div>
          </div>
        </section>
      )}
      <section className="layout clientScanner">
        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col-md-8 col-lg-6 order-2 order-md-1">
              <h5 className="mb-4 h4">Think your idea makes lives simpler?</h5>
              <p className="b6">
                We can help you transform your business. Welcome to the age of
                Artificial Intelligence.
                <br />
                <br />
                Onboard and take your business to the next level. Send a message
                to{" "}
                <a
                  href="mailto:hello@tarento.com?subject=Client Requirement"
                  className="font-weight-bold lead"
                >
                  hello@tarento.com
                </a>{" "}
                and we will contact you within one business day.
              </p>
              <a
                href="mailto:hello@tarento.com?subject=Client Requirement"
                className="btn btn-primary mt-5"
              >
                Get in touch
              </a>
            </div>
            <div className="col-md-3  order-1 ">
              <div className="scanner">
                <img
                  src="/images/common/scannerCode.jpg"
                  alt="QR code scanner"
                  title="QR code scanner"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="featureClient">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="clientOpt d-flex justify-content-between align-items-center">
                {props.post.previous && (
                  <div className="pre">
                    <Link to={props.post.previous.node.slug + "/"}>
                      <div className="arrow mb-3">
                        <img
                          src="/images/common/pre.svg"
                          alt="Previous"
                          title="Previous"
                        />
                      </div>
                      <h6 className="white9">
                        {props.post.previous.node.title}
                      </h6>
                    </Link>
                  </div>
                )}
                <div className="hairline">
                  {/* <a href=""> */}
                    <img
                      src="/images/common/galleryIcon.svg"
                      alt="Gallery"
                      title="Gallery"
                    />
                  {/* </a> */}
                </div>
                {props.post.next && (
                  <div className="nxt text-right">
                    <Link to={props.post.next.node.slug + "/"}>
                      <div className="arrow mb-3">
                        <img
                          src="/images/common/nxt.svg"
                          alt="Previous"
                          title="Previous"
                        />
                      </div>
                      <h6 className="white9">{props.post.next.node.title}</h6>
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}
